<template>
    <div data-slider ref="slider" v-if="length > 0">
        <div class="swiper-wrapper">
            <template v-for="(item, index) in items">
                <slot
                        name="body"
                        :item="item"
                        :index="index"
                ></slot>
            </template>
        </div>
        <slot name="navigation"></slot>
    </div>
</template>
<script>
    import Swiper from 'swiper';

    export default {
        props: {
            items: {
                type: Array,
                default: () => [],
            },
            config: {
                type: Object,
                default: () => {
                    return {};
                },
            },
        },
        data() {
            return {
                slider: null,
                defaultConfig: {
                    effect: 'slide',
                    slideClass: 'slide',
                    slideActiveClass: 'slide-active',
                    slideVisibleClass: 'slide-visible',
                    slideDuplicateClass: 'slide-duplicate',
                    slideNextClass: 'slide-next',
                    slidePrevClass: 'slide-prev',
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    slidesPerView: 1,
                    paginationClickable: true,
                    spaceBetween: 0,
                    loop: true,
                    speed: 2000,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                    },
                    a11y: true,
                },
            };
        },
        computed: {
            length() {
                return this.items.length;
            },
        },
        beforeDestroy() {
            if (this.slider === null) {
                return;
            }
            this.slider.destroy();
        },
        mounted() {
            if (this.length === 0) {
                return;
            }
            setTimeout(() => {
                this.initialize();
            }, 1000);
        },
        methods: {
            initialize() {

                let element = this.$refs.slider;

                if (this.length < 2) {
                    element.classList.add('disabled');
                    return;
                }

                this.slider = new Swiper(element, this.swiperConfig(element));
            },
            swiperConfig(element) {
                return Object.assign(
                    this.defaultConfig,
                    {
                        pagination: {
                            el: element.getElementsByClassName('swiper-pagination'),
                            type: 'bullets',
                            clickable: true,
                        },
                    },
                    this.config,
                );
            },
        },
    };
</script>
